import { COLORS } from "../styles/uiConstants";

// "72,5" gibi virgüllü girişleri de kabul eden sayı okuyucu; geçersizse null.
const toNumber = (raw) => {
  const text = String(raw ?? "").trim();
  if (!text) return null;
  const n = Number(text.replace(",", "."));
  return Number.isFinite(n) ? n : null;
};

// BMI = kilo (kg) / boy (m)². Boy cm cinsinden alınır; sonuç 1 ondalığa
// yuvarlanır. Makul aralık dışındaki girişlerde null döner.
export const calculateBmi = (heightCm, weightKg) => {
  const h = toNumber(heightCm);
  const w = toNumber(weightKg);
  if (h == null || w == null) return null;
  if (h < 50 || h > 250 || w < 2 || w > 400) return null;
  const meters = h / 100;
  return Math.round((w / (meters * meters)) * 10) / 10;
};

// Dünya Sağlık Örgütü BMI sınıfları; normal dışı değerler renkli gösterilir.
export const bmiCategory = (raw) => {
  const n = toNumber(raw);
  if (n == null || n <= 0) return null;
  if (n < 18.5) return { label: "Zayıf", color: COLORS.warningDark };
  if (n < 25) return { label: "Normal", color: null };
  if (n < 30) return { label: "Fazla kilolu", color: COLORS.warningDark };
  return { label: "Obez", color: COLORS.errorDark };
};
